// Copyright (c) Docugami, Inc. All rights reserved.

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect } from "react";
import { Redirect, Route, Switch, useLocation, useRouteMatch } from "react-router-dom"
import { selectIsLimitedOrganization } from "store/AccountInfoHelpers";
import { setNavigationBarVisibility } from "store/display/actions";
import { NewWorkPathPage, WorkPathPage } from "./WorkPathPage";

export const WorkPathRouting = () => {
    const location = useLocation()
    const match = useRouteMatch();
    const dispatch = useAppDispatch();
    const isLimitedOrg = useAppSelector((state) => selectIsLimitedOrganization(state));

    // Hide navigation bar by default in the workpath view
    useEffect(() => {
        dispatch(setNavigationBarVisibility(false));

        // Set navigation bar visibility to true on unmount
        return () => {
            dispatch(setNavigationBarVisibility(true));
        }
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [])

    // The org is expired, redirect back to home
    if (isLimitedOrg) {
        return <Redirect to="/home" />
    }

    return (
        <Switch>
            <Route path={[
                `${match.path}/new/:type`]}
                component={NewWorkPathPage}
                location={location} />
            <Route path={[
                `${match.path}/:id`]}
                component={WorkPathPage}
                location={location} />
        </Switch>
    )
}